import { BaseService } from "@/api/baseService";
import httpRequest from "@/api/index";
import type { Page } from "../../../../common/types/base/BaseEntity";
import type { UserMessage, UnreadMessageNum } from "@zhihaoscm/entity";
const getUrl = (path: string, type: number) => {
    return type ? path + `?type=${type}` : path;
};
export class UserMessageService extends BaseService<UserMessage, UserMessage, any, any> {
    // 全部已读
    async allReaded(type: number) {
        const url = getUrl(this.path + "/readedAll", type);
        console.log(url, "--------------url");
        await this.service.post(url, {});
    }
    // 批量已读 您确定要标记选中的1条消息为已读吗
    async batchReaded(ids: number[], type: number) {
        const url = getUrl(this.path + "/readed", type);
        await this.service.post(url, ids);
    }
    // 删除
    async batchDel(ids: number[], type: number) {
        const url = getUrl(this.path + "/batchDelete", type);
        await this.service.post(url, ids);
    }
    // 删除
    async allDel(type: number) {
        const url = getUrl(this.path + "/deleteAll", type);
        await this.service.post(url, {});
    }
    // 分页查询
    async paging(params: any): Promise<Page<UserMessage>> {
        const { data } = await this.service.get(this.path + "/paging", { params });
        return data;
    }
    // 获取各类型 未读消息数量
    async getMsgNum(): Promise<UnreadMessageNum> {
        const { data } = await this.service.post(this.path + "/getUnreadMessage", {});
        return data;
    }
    // 获取消息跳转实体是否存在 0 代表不存在 1 代表存在
    async getMsgEntity(params: { id: number }) {
        const { data } = await this.service.get(this.path + "/entity/exist", { params });
        return data;
    }
}

export const userMessageService = new UserMessageService("/user/message", httpRequest);
